module.exports = __webpack_public_path__ + "media/ting.4168ac99.ogg";